<template>
  <div class="list-page">
    <div class="overlay"></div>
    <Header />
    
    <section class="nei-banner" :style="{ background: ' url(' + require('@/assets/images/banner.jpg') + ') center/cover no-repeat' }">
      <div class="container">
        <div class="banner-content"> 
          <h1>新闻中心</h1>
          <h2>洞察行业趋势，见证腾智创新力量</h2>
          <p>腾智科技新闻中心聚焦制造业数字化前沿动态，实时更新企业战略、产品升级、标杆案例及行业洞察，为用户、合作伙伴及媒体提供权威信息窗口，传递腾智"技术赋能制造"的核心价值</p>
        </div>
      </div>
    </section>

    <main class="main-content">
      <div class="container">
        <div class="news-categories">
          <a href="#" :class="['category', { active: activeCategory === 'all' }]" @click.prevent="activeCategory = 'all'">全部</a>
          <a href="#" :class="['category', { active: activeCategory === 'company' }]" @click.prevent="activeCategory = 'company'">公司新闻</a>
          <a href="#" :class="['category', { active: activeCategory === 'industry' }]" @click.prevent="activeCategory = 'industry'">行业动态</a>
          <a href="#" :class="['category', { active: activeCategory === 'tech' }]" @click.prevent="activeCategory = 'tech'">技术创新</a>
          <a href="#" :class="['category', { active: activeCategory === 'case' }]" @click.prevent="activeCategory = 'case'">客户案例</a>
        </div>

        <div class="news-list">
          <router-link to="/show" v-for="(news, index) in newsList" :key="index" class="news-item">
            <article>
              <div class="news-image">
                <img :src="require(`@/assets/images/${news.image}`)" :alt="news.title">
                <span class="news-category">{{ news.category }}</span>
              </div>
              <div class="news-content">
                <h3 class="news-title">{{ news.title }}</h3>
                <p class="news-excerpt">{{ news.excerpt }}</p>
                <div class="news-meta">
                  <span><i class="far fa-calendar"></i>{{ news.date }}</span>
                  <span><i class="far fa-eye"></i>{{ news.views }}次浏览</span>
                </div>
              </div>
            </article>
          </router-link>
        </div>

        <div class="pagination">
          <a href="#" class="page-item active">1</a>
          <a href="#" class="page-item">2</a>
          <a href="#" class="page-item">3</a>
          <span class="page-dots">...</span>
          <a href="#" class="page-item">8</a>
          <a href="#" class="page-next">
            <i class="fas fa-angle-right"></i>
          </a>
        </div>
      </div>
    </main>
    
    <Footer />
    <SideService />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import SideService from '@/components/SideService.vue';

export default {
  name: 'List',
  components: {
    Header,
    Footer,
    SideService
  },
  data() {
    return {
      activeCategory: 'all',
      newsList: [
        {
          id: 1,
          image: 'kcglkc.jpg',
          date: '2024-12-20',
          category: '公司新闻',
          title: '智能仓储库存系统的预测与补货决策支持',
          excerpt: '智能仓储库存系统的预测与补货决策支持是通过整合先进的数据分析技术...',
          views: '1,556'
        },
        {
          id: 2,
          image: 'news2.jpg',
          date: '2023-12-20',
          category: '行业动态',
          title: '数字化转型加速，制造业ERP系统需求激增',
          excerpt: '后疫情时代，制造业数字化转型明显加速，企业对智能制造解决方案的需求持续攀升...',
          views: '1,856'
        },
        {
          id: 3,
          image: 'news5.jpg',
          date: '2023-12-05',
          category: '技术创新',
          title: '腾智发布新一代AI智能排产系统，引领制造业智能化变革',
          excerpt: '新系统采用深度学习算法，可实现生产计划的智能优化，大幅提升排产效率...',
          views: '1,987'
        },
        {
          id: 4,
          image: 'news6.jpg',
          date: '2023-12-01',
          category: '行业动态',
          title: '2024年制造业数字化转型趋势展望',
          excerpt: '随着工业4.0的深入推进，智能制造、数字孪生等技术将在2024年迎来新的发展机遇...',
          views: '2,245'
        }
      ]
    }
  },
  mounted() {
    // 初始化AOS动画库
    if (typeof AOS !== 'undefined') {
      AOS.init({
        duration: 1000,
        once: true
      });
    }
  }
}
</script>

<style scoped>
Zskt.vue还有一些显示上的问题，可以参照zskt.html
1 整体板块都缺少css样式:root {
  --primary-color: #009b7b;
}

/* Banner样式 */
.nei-banner {
  position: relative;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  margin-bottom: 3rem;
}

.banner-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
}

.banner-content h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  word-wrap: break-word;
}

.banner-content h2 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  word-wrap: break-word;
}

.banner-content p {
  font-size: 1.1rem;
  line-height: 1.6;
  word-wrap: break-word;
}

/* 新闻分类 */
.news-categories {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 3rem;
  flex-wrap: wrap;
}

.category {
  padding: 0.8rem 2rem;
  background: #f0f0f0;
  border-radius: 25px;
  text-decoration: none;
  color: #333;
  transition: all 0.3s;
  cursor: pointer;
}

.category:hover,
.category.active {
  background: var(--primary-color);
  color: white;
}

/* 新闻列表 */
.news-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
}

.news-item {
  text-decoration: none;
  color: inherit;
  transition: all 0.3s;
  display: block;
}

.news-item:hover {
  transform: translateY(-5px);
}

.news-item article {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.news-item:hover article {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
}

.news-image {
  position: relative;
  overflow: hidden;
  height: 200px;
}

.news-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.news-item:hover .news-image img {
  transform: scale(1.1);
}

.news-category {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 155, 123, 0.9);
  color: white;
  padding: 0.3rem 1rem;
  border-radius: 20px;
  font-size: 0.85rem;
}

.news-content {
  padding: 1.5rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.news-title {
  font-size: 1.2rem;
  margin-bottom: 1rem;
  line-height: 1.4;
  color: #333;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-excerpt {
  color: #666;
  line-height: 1.6;
  margin-bottom: 1rem;
  flex-grow: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-meta {
  display: flex;
  justify-content: space-between;
  color: #999;
  font-size: 0.9rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

.news-meta span {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

/* 分页 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin: 3rem 0;
  padding: 2rem 0 4rem 0;
}

.page-item,
.page-next {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  text-decoration: none;
  color: #333;
  transition: all 0.3s;
}

.page-item:hover,
.page-next:hover {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.page-item.active {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.page-dots {
  padding: 0 0.5rem;
  color: #999;
}

@media (max-width: 992px) {
  .banner-content {
    padding: 0 30px;
  }

  .banner-content h1 {
    font-size: 2.2rem;
  }

  .banner-content h2 {
    font-size: 1.4rem;
  }

  .banner-content p {
    font-size: 1rem;
  }

  .news-list {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
}

@media (max-width: 768px) {
  .nei-banner {
    height: auto;
    min-height: 300px;
    padding: 60px 0;
  }

  .banner-content {
    padding: 0 20px;
  }

  .banner-content h1 {
    font-size: 1.8rem;
    line-height: 1.3;
  }

  .banner-content h2 {
    font-size: 1.2rem;
    line-height: 1.4;
  }

  .banner-content p {
    font-size: 0.95rem;
    line-height: 1.6;
  }

  .news-categories {
    gap: 1rem;
  }

  .news-list {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .banner-content h1 {
    font-size: 1.5rem;
  }

  .banner-content h2 {
    font-size: 1rem;
  }

  .banner-content p {
    font-size: 0.9rem;
  }
}
</style>